import React from "react"
import Markdown from "markdown-to-jsx"
import { string } from "yup"
import { Button } from "@material-ui/core"
import DefaultButton from "../DefaultButton"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import ConfirmationModal from "../ConfirmationModal"

const MAX_LENGTH = 1000

const elements = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",

  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan",
]

const allowedElements = ["a", "b", "strong", "em", "u", "code", "del"]

const CustomLink = ({ children, ...props }) => (
  <a {...props} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
)

const MarkdownWrapper = ({ children }) => {
  const [isExpanded, setIsExpanded] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)

  const options = React.useMemo(() => {
    const markdownOptions = {
      disableParsingRawHTML: true,
      forceInline: true,
      overrides: {
        a: { component: CustomLink },
      },
    }

    elements.forEach((element) => {
      if (!allowedElements.includes(element)) {
        markdownOptions.overrides[element] = (el) => el.children || null
      }
    })

    return markdownOptions
  }, [])

  if (typeof children !== "string") {
    return children
  }

  if (!children) return null

  let processedChildren = children
  const boldRegex = /\*(.*?)\*/g
  const tildaRegex = /~(.*?)~/g

  if (processedChildren && boldRegex.test(processedChildren)) {
    processedChildren = processedChildren.replace(boldRegex, "**$1**")
  }
  if (processedChildren && tildaRegex.test(processedChildren)) {
    processedChildren = processedChildren.replace(tildaRegex, "~~$1~~")
  }

  if (processedChildren.length > MAX_LENGTH && !isExpanded) {
    const truncatedText = processedChildren.slice(0, MAX_LENGTH) + "..."
    return (
      <>
        <div>
          <Markdown options={options}>{truncatedText}</Markdown>
          <DefaultButton
            stylization={"text"}
            onClick={() => {
              if (processedChildren.length >= 90000) {
                setShowModal(true)
              } else {
                setIsExpanded(true)
              }
            }}
          >
            Leia mais
          </DefaultButton>
        </div>
        {showModal && (
          <ConfirmationModal
            open={showModal}
            Primeiro={"Abrir"}
            onClose={() => setShowModal(false)}
            onConfirm={() => setIsExpanded(true)}
          >
            <p>Você realmente deseja abrir essa mensagem?</p>
            <p>Esta menssagem tem {processedChildren.length} caracteres, isso pode travar a sua conversa </p>
          </ConfirmationModal>
        )}
      </>
    )
  }

  if (processedChildren.length > MAX_LENGTH && isExpanded) {
    return (
      <div>
        <Markdown options={options}>{processedChildren}</Markdown>
        <DefaultButton stylization={"text"} onClick={() => setIsExpanded(false)}>
          Leia menos
        </DefaultButton>
      </div>
    )
  }

  return <Markdown options={options}>{processedChildren}</Markdown>
}

export default MarkdownWrapper
